module.exports = __webpack_public_path__ + "trust-marks-duct-tape-marketing.9c0a01.png";